import React, { useEffect, MutableRefObject } from 'react';

const useClickOutside = <T extends HTMLElement | HTMLDivElement>(
  ref: React.RefObject<T>,
  callback: (event: MouseEvent) => void,
): void => {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      setTimeout(() => {
        if (ref.current && !ref.current.contains(e.target as Node)) {
          callback(e);
        }
      }, 10);
    };

    document.addEventListener('click', handleClick);

    return (): void => {
      document.removeEventListener('click', handleClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref as MutableRefObject<T>, callback]);
};

export default useClickOutside;
